/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from "react";
import { MarkdownContent, Loading } from "@/shared/ui";
import { useTranslation } from "react-i18next";
import PolicyPageLayout from "./PolicyPageLayout";
import { useDocumentContent } from "../shared/hooks/useDocumentContent";
import { PageSEO, HreflangTags, BreadcrumbSchema } from "@/shared/seo";

const ServiceTermsVersion2: React.FC = () => {
  const { t } = useTranslation("@pages/policy");
  const { content, isLoading } = useDocumentContent(
    'service-terms',
    `# ${t("serviceTerms.title")}\n\nContent coming soon.`,
    2
  );

  if (isLoading) return <Loading mode="section" size="lg" />;

  return (
    <>
      <PageSEO
        title={t("serviceTerms.title")}
        description={t("serviceTerms.description", "Terms of Service for Housien - Read our terms and conditions for using our platform.")}
        noIndex={false}
      />
      <HreflangTags />
      <BreadcrumbSchema
        items={[
          { name: t("breadcrumb.home"), url: "/" },
          { name: t("serviceTerms.title"), url: "/serviceterms/v2" },
        ]}
      />

      <PolicyPageLayout
        title={t("serviceTerms.title")}
        lastUpdated="April 2026"
        version="2"
        lastUpdatedLabel={t("serviceTerms.lastUpdated")}
        versionLabel={t("serviceTerms.version")}
      >
        <MarkdownContent content={content} headingOffset={1} />
      </PolicyPageLayout>
    </>
  );
};

export default ServiceTermsVersion2;
